export enum ToolType {
    Axe,
    Pickaxe,
    Scythe,
}